import { Link } from "@remix-run/react";

export const getStringWithStaticDataLinks = (string: string) => {
  // Replace all occurrences of [label](url) with a <a> element and just return a string (it's for structured data purposes)
  return string.replace(/\[([^\]]+)\]\((http[^)]+)\)/g, "$1");
};

export const StaticDataParser = ({ string }: { string: string }) => {
  // This regular expression will match and capture the label and URL parts of the string
  const regex = /\[([^\]]+)\]\((http[^)]+)\)/g;

  let result,
    lastIndex = 0;
  const parts = [];

  while ((result = regex.exec(string)) !== null) {
    const textBeforeLink = string.slice(lastIndex, result.index);
    if (textBeforeLink) {
      parts.push(textBeforeLink);
    }

    // Push the React <a> element
    parts.push(
      <Link
        to={result[2] || ""}
        key={result[2]}
        className="font-medium text-primary hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {result[1]}
      </Link>
    );

    lastIndex = regex.lastIndex;
  }

  // If there's any text after the last link
  const textAfterLastLink = string.slice(lastIndex);
  if (textAfterLastLink) {
    parts.push(textAfterLastLink);
  }

  return parts;
};
